import { filtersApiRequests } from 'utils/api-requests/filters';
import { v2filtersApiRequests } from 'utils/api-requests/v2filters';
import { LocationOptionsType } from 'utils/types/Locations';
import { LocationItem } from 'utils/types/V2Locations';

export const getVoivodeshipCities = async (voivodeship: string, locations: LocationOptionsType[]) => {
    const voivodeshipId = locations.find((x) => x.label === voivodeship)?.voivodeshipNumber;
    const voivodeshipCities = locations.find((x) => x.label === voivodeship)?.cities;
    if (voivodeshipCities && voivodeshipCities.length > 0) return locations;

    const cities = await filtersApiRequests.getVoivodeshipCities(voivodeshipId!);

    return locations.map((x) => {
        if (x.voivodeshipNumber === voivodeshipId) {
            return { ...x, cities: cities };
        }

        return x;
    });
};

export const v2getVoivodeshipCities = async (voivodeshipId: number, locations: LocationItem[]) => {
    const voivodeship = locations.find((x) => x.id === voivodeshipId);

    if (voivodeship && voivodeship.children && voivodeship.children.length > 0) {
        return locations;
    }

    const cities = await v2filtersApiRequests.getVoivodeshipCities(voivodeshipId);

    return locations.map((x) => {
        if (x.id === voivodeshipId) {
            return { ...x, children: cities };
        }

        return x;
    });
};
